/**
 * Packaging OS — ReportSection (Phase 1P-B).
 *
 * One titled card containing report content. Used by the dry-run report
 * renderer to compose the 12 controlled blocks side-by-side / stacked.
 */

import type { ReactNode } from "react";

interface ReportSectionProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function ReportSection({
  title,
  subtitle,
  children,
}: ReportSectionProps): JSX.Element {
  return (
    <section className="po-report-section">
      <h2 className="po-report-section__title">{title}</h2>
      {subtitle && <p className="po-report-section__subtitle">{subtitle}</p>}
      {children}
    </section>
  );
}

interface BulletListProps {
  items: string[];
  empty?: string;
}

export function BulletList({ items, empty }: BulletListProps): JSX.Element {
  if (items.length === 0 && empty) {
    return <p className="po-note po-note--muted">{empty}</p>;
  }
  return (
    <ul className="po-list">
      {items.map((item, index) => (
        <li key={`${index}-${item.slice(0, 20)}`}>{item}</li>
      ))}
    </ul>
  );
}
